import 'cap-widget';
import { useEffect, useRef } from 'react';

export default function CaptchaInput({
  api,
  onChange,
}: {
  api: any;
  onChange: (token: string) => void;
}) {
  if (!api) return console.error('CaptchaInput requires an API instance', api);

  const widgetRef = useRef<any | null>(null);

  const handleSolve = (e: CustomEvent) => {
    onChange(e?.detail?.token);
  };

  const handleError = (e: CustomEvent) => {
    console.error('Captcha error:', e?.detail?.message);
  };

  /*const handleProgress = (e: CustomEvent) => {
    console.log('Captcha progress:', e.detail.progress);
  };*/

  const handleReset = () => {
    console.log('Captcha reset');
    onChange('');
  };

  useEffect(() => {
    widgetRef.current?.addEventListener('solve', handleSolve);
    widgetRef.current?.addEventListener('error', handleError);
    //widgetRef.current?.addEventListener('progress', handleProgress);
    widgetRef.current?.addEventListener('reset', handleReset);
    return () => {
      widgetRef.current?.removeEventListener('solve', handleSolve);
      widgetRef.current?.removeEventListener('error', handleError);
      //widgetRef.current?.removeEventListener('progress', handleProgress);
      widgetRef.current?.removeEventListener('reset', handleReset);
    };
  }, [handleReset, handleError, handleSolve]);

  return <cap-widget ref={widgetRef} data-cap-api-endpoint={`${api.host()}/captcha`} />;
}

CaptchaInput._hookable = true;
